export default __webpack_public_path__ + "static/media/zicklet-trio.99c54ef2.png";